export const SERVER_API_ENDPOINT = process.env.REACT_APP_API
export const SERVER_FILE_ENDPOINT = process.env.REACT_APP_ENDPOINT_FILE || 'https://hp-media.sgp1.cdn.digitaloceanspaces.com'
export const SERVER_API_SOCKET = process.env.REACT_APP_API
